import { useEffect } from "react";
import { ContainerV2, H1, P } from "../../Atoms";
import { Tracking } from "../../../services/Tracking";
import { maskMoney } from "../../../utils/masks";
import { usePixConfirmationV2 } from "./usePixConfirmationV2";

export const PixConfirmationV2 = () => {
  const { stepIndicator, servico, modalidade, valorTotal, handleRealizarAgendamento } =
    usePixConfirmationV2();

  useEffect(() => {
    Tracking.pageView(
      "mapa:agendamento/pagamento/pix/confirmacao:pageview",
    );
  }, []);

  return (
    <ContainerV2
      backButton={false}
      nextButton={{
        title: "Realizar Agendamento",
        onClick: handleRealizarAgendamento,
        className: "w-full max-w-[400px]",
      }}
    >
      {stepIndicator}
      <H1 className="mb-4 mt-8">Pagamento</H1>
      <P className="mb-8 text-[#666666]">
        Após a aprovação você irá definir a data e horário.
      </P>

      <div className="flex flex-col items-center gap-6">
        <div className="flex h-[120px] w-[120px] items-center justify-center rounded-full bg-[#e7f7f4] shadow-[0_12px_32px_0_rgba(111,165,153,0.25)]">
          <img
            src="/assets/svgs/icon-check-check-green.svg"
            alt=""
            className="h-12 w-12"
          />
        </div>
        <p className="font-['Mulish'] text-[32px] font-extrabold leading-[1.2] text-[#6fa599]">
          Pagamento Confirmado!
        </p>
      </div>

      <div className="mx-auto mt-12 flex w-full max-w-[560px] flex-col gap-6 rounded-3xl border border-solid border-[#adb7b5] bg-white p-8 shadow-[0_8px_24px_0_rgba(0,0,0,0.078)]">
        <p className="font-['Mulish'] text-xl font-extrabold text-[#20332f]">
          Resumo do Agendamento
        </p>

        <div className="flex flex-col gap-4">
          <div className="flex items-center justify-between border-x-0 border-b border-t-0 border-solid border-[#e5e5ea] pb-3">
            <span className="font-['Mulish'] text-sm text-[#666666]">
              Serviço
            </span>
            <span className="font-['Inter'] text-xs font-bold text-[#20332f]">
              {servico ?? "---"}
            </span>
          </div>
          <div className="flex items-center justify-between border-x-0 border-b border-t-0 border-solid border-[#e5e5ea] pb-3">
            <span className="font-['Mulish'] text-sm text-[#666666]">
              Modalidade
            </span>
            <span className="font-['Inter'] text-xs font-bold text-[#20332f]">
              {modalidade ?? "---"}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="font-['Mulish'] text-sm text-[#666666]">
              Valor Total
            </span>
            <span className="font-['Inter'] text-lg font-extrabold text-[#6fa599]">
              {maskMoney((valorTotal ?? 0) / 100)}
            </span>
          </div>
        </div>

        <div className="flex items-center gap-3 rounded-xl bg-[#fafcfe] p-4">
          <img
            src="/assets/svgs/icon-calendar-check-green.svg"
            alt=""
            className="h-5 w-5 shrink-0"
          />
          <span className="font-['Inter'] text-sm text-[#20332f]">
            Data e horário serão selecionados no próximo passo.
          </span>
        </div>
      </div>
    </ContainerV2>
  );
};
